import AdminsTable from './AdminsTable';

export default AdminsTable;
